import {
  SEARCH_CUSTOMER_REQUEST_FAIL,
  SEARCH_CUSTOMER_REQUEST_SUCCESS,
  RESET_CUSTOMER_SEARCH
} from '../action.types'
import InitialState from '../initial.state'

export default (state = InitialState.searchCustomer, action) => {
  switch (action.type) {
    case SEARCH_CUSTOMER_REQUEST_SUCCESS:
      return [...action.payload]
    case SEARCH_CUSTOMER_REQUEST_FAIL:
      return state
    case RESET_CUSTOMER_SEARCH:
      return InitialState.searchCustomer
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/customer/searchcustomer.reducer.js